import { useShotPanelStore } from "@/stores/shot-panel-store"

function isCurrentLocation(to: string): boolean {
  const url = new URL(to, window.location.origin)
  return url.pathname === window.location.pathname && url.search === window.location.search
}

/**
 * Клик по пункту оболочки значит «покажи раздел»: открытый шот прячем (промпт сохраняется).
 * true — раздел уже открыт и грузить нечего: клик гасим, закрывается только шот.
 */
export function closeShotForShellNav(to: string | null): boolean {
  const shotPanel = useShotPanelStore.getState()
  if (!shotPanel.open) return false
  shotPanel.requestClose()
  return to != null && isCurrentLocation(to)
}
